import { Authenticated } from "@refinedev/core";
import { ProjectInit } from "../home/components/ProjectInit";
import { ComplianceFooter } from "./components/ComplianceFooter";

export const ProjectDocumentPage = () => {
  return (
    <Authenticated key="projectDocument">
      <ProjectInit showHeyGeniusButton={true} />
      <ComplianceFooter />
    </Authenticated>
  );
};
